module.exports = __webpack_public_path__ + "static/media/1.baa62bdb.jpg";